import { startTransition, useEffect, useState } from "react";
import hasWindow from "@src/utils/hasWindow";
import isTouchDevice from "@src/utils/isTouchDevice";

const useLoadAfterInteraction = () => {
  // global key to store first interaction
  const firstInteractionKey = "__firstInteraction";
  const defaultState: boolean =
    // @ts-ignore
    (hasWindow() && window[firstInteractionKey]) || false;
  const [initialLoad, setInitialLoad] = useState(defaultState);

  useEffect(() => {
    if (defaultState || initialLoad) return;
    const isTouch = isTouchDevice();
    const stopListening = () => {
      window.removeEventListener("scroll", handle);
      window.removeEventListener("click", handle);
      window.removeEventListener("rs-force-after-interaction", handle);
      !isTouch && window.removeEventListener("mousemove", handle);
      isTouch && window.removeEventListener("touchstart", handle);
    };
    const handle = (_e?: Event) => {
      if (!initialLoad) {
        stopListening();
        // @ts-ignore
        window[firstInteractionKey] = true;
        const forceImmediate =
          _e?.type === "rs-force-after-interaction" || _e?.type === "click";
        if (forceImmediate) {
          // Sync : ProductModal doit pouvoir lire openProduct au 1er clic listing.
          setInitialLoad(true);
          return;
        }
        startTransition(() => {
          setTimeout(() => {
            setInitialLoad(true);
          }, isTouch ? 800 : 0);
        });
      }
    };
    if (!initialLoad) {
      window.addEventListener("scroll", handle);
      window.addEventListener("click", handle, { capture: true, passive: true });
      window.addEventListener("rs-force-after-interaction", handle);
      !isTouch && window.addEventListener("mousemove", handle);
      isTouch && window.addEventListener("touchstart", handle);
    }
    return () => {
      stopListening();
    };
  }, [initialLoad]);

  return initialLoad;
};

export default useLoadAfterInteraction;
